import { Component, OnInit } from '@angular/core';
import { SeedService } from '../seed.service'

@Component({
  selector: 'app-seed-box',
  templateUrl: './seed-box.component.html',
  styleUrls: ['./seed-box.component.css']
})
export class SeedBoxComponent implements OnInit {
  private currentSeedSelection: string
  fn: string

  constructor(
    public ss: SeedService
  ) { }

  ngOnInit() {
  }

  selectSeed(seedId) {
    if (this.currentSeedSelection == seedId)
      this.currentSeedSelection = null
    else
      this.currentSeedSelection = seedId
  }

  run() {
    if (!this.currentSeedSelection)
      return alert('SEEDED PROJECT NOT SELECTED')
    if (!this.fn)
      return alert("Filename must be given")
    this.ss.run(this.currentSeedSelection, this.fn)
  }

  runSupport() {
    if (!this.currentSeedSelection)
      return alert('SEEDED PROJECT NOT SELECTED')
    this.ss.runSupport(this.currentSeedSelection)
  }


}



// WEBPACK FOOTER //
// ./src/app/seed-box/seed-box.component.ts